<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Usuarios</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#7c167d"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              :disabled="disabledBtnNuevo"
            >Nuevo</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.id" label="Id" color="#7c167d"></v-text-field>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.name" label="Nombre" color="#7c167d"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.email" label="Email" color="#7c167d"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.rol" label="Rol" color="#7c167d"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field v-model="editedItem.password" label="Password" color="#7c167d"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#7c167d" text @click="close">Cancelar</v-btn>
              <v-btn color="#7c167d" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
  import axios from "axios";
  import {api_url} from '../config/index';
  export default {
    data: () => ({
      disabledBtnNuevo: true,
      dialog: false,
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Email', value: 'email' },
        { text: 'Rol', value: 'rol' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        email: '',
        rol: '',
        password: ''
      },
      defaultItem: {
        name: '',
        email: '',
        rol: '',
        password: ''
      },
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo' : 'Editar'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        this.isLoading = true;
          await axios.get(`${api_url}/users/`, {
            headers: {
              'user_token': sessionStorage.getItem('token')
              }
            }).then((response) => {      
                this.desserts = [];           
                let data = response.data;
                console.log(data);
                if (data.error) 
                  this.$swal(
                              'Error!',
                              data.error,
                              'error'
                            )

                this.disabledBtnNuevo= false;
                this.desserts = data;
                //this.desserts.push(registro);
              }).catch((err) => {
                  console.log(err);
              });          
        this.isLoading = false;
      },

      editItem (item) {
        console.log('Edit Item::', item);
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        console.log(item);
        this.$swal({
              title: 'Eliminar Usuario',
              text: `¿Estas seguro que deseas eliminar a ${item.name} como usuario?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Sí, eliminar!'
            }).then((result) => {
              if (result.value) {
                this.eliminarUsuario(item)
              }
            });
      },
      async eliminarUsuario(item){
        await axios.delete(`${api_url}/users/${item.id}`, {
            headers: {
              'user_token': sessionStorage.getItem('token')
              }
            }).then((response) => {  
                let data = response.data;

                if (data.error) {
                  this.$swal(
                              'Error!',
                              data.error,
                              'error'
                            )
                }            
                else { 
                  this.$swal(
                    'Exito',
                    'Eliminación de usuario realizada exitosamente!!',
                    'success'
                  )
                  this.initialize()
                }  
              }).catch((err) => {
                  console.log(err);
              });         
      }
      ,
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        console.log('EDIT ',this.editedItem);
        console.log('Opcion::',this.editedIndex);
         let userData = {
           id: this.editedItem.id,
           name: this.editedItem.name,
           email: this.editedItem.email,
           rol: this.editedItem.rol,
           password: this.editedItem.password
         }

        if (this.editedIndex > -1) {
            this.update(userData);
        } else {
            this.new(userData);
        }
        this.close()
      },
      async update(userData) {
         console.log('UPDATE:', userData); 
         await axios.put(`${api_url}/users/`, userData, {
            headers: {
              'user_token': sessionStorage.getItem('token')
              }
            }).then((response) => {  
                let data = response.data;

                if (data.error) {
                  this.$swal(
                              'Error!',
                              data.error,
                              'error'
                            )
                }            
                else { 
                  this.$swal(
                    'Exito',
                    'Actuación de usuario realizada exitosamente!!',
                    'success'
                  )
                  this.initialize()
                }  
              }).catch((err) => {
                  console.log(err);
              });  
      },
      async new(userData) {
        console.log('NEW:', userData);
        await axios.post(`${api_url}/users/`, userData, {
            headers: {
              'user_token': sessionStorage.getItem('token')
              }
            }).then((response) => {  
                let data = response.data;

                if (data.error) {
                  this.$swal(
                              'Error!',
                              data.error,
                              'error'
                            )
                }            
                else { 
                  this.$swal(
                    'Exito',
                    'Creación de usuario realizado exitosamente!!',
                    'success'
                  )
                  this.initialize()
                }  
              }).catch((err) => {
                  console.log(err);
              });  
      },
    },
  }
</script>